import EntityManagerRow       from '@/pages/Entity/components/Rows/EntityManagerRow';
import { Tooltip }            from '@/components/ui/tooltip';
import { Button }             from '@/components/ui/button';
import ContactModel           from '@/models/services/network/ContactModel';
import EntityModel            from '@/models/services/fondations/EntityModel';
import FileModel              from '@/models/services/file/FileModel';
import useEntityManagersBox   from '@/pages/Entity/hooks/useEntityManagersBox';
import { Box }                from '@chakra-ui/react';
import { Text }               from '@chakra-ui/react';
import { HiPlus }             from 'react-icons/hi';
import { useTranslation }     from 'react-i18next';

interface IEntityManagersBoxProps {
	entity:             EntityModel;
	managers:           ContactModel[];
	assignableContacts: ContactModel[];
	contactFiles:       { contactId: string; file: FileModel }[];
	isReadOnly?:        boolean;
	onRolesChange:      () => void;
}

const EntityManagersBox = ({
	entity,
	managers,
	assignableContacts,
	contactFiles,
	isReadOnly,
	onRolesChange,
}: IEntityManagersBoxProps) => {
	const { t } = useTranslation();

	const { modalElement, openAssignModal, openDeleteModal } = useEntityManagersBox({
		entity,
		assignableContacts,
		onSuccess: onRolesChange,
	});

	return (
		<>
			{modalElement}

			<Box
				backgroundColor="white"
				borderRadius="md"
				boxShadow="md"
				padding="20px"
				flex="1"
				minWidth="280px"
			>
				<Box display="flex" alignItems="center" justifyContent="space-between" mb="15px">
					<Text className="poppins-semibold" fontSize="16px">{t('pages.entity.managers.title')}</Text>
					<Tooltip content={t('pages.entity.managers.actions.assign.tooltip')} showArrow>
						<AddButton onClick={openAssignModal} disabled={isReadOnly} />
					</Tooltip>
				</Box>

				{managers.length === 0 ? (
					<Text fontSize="14px" color="gray.400">{t('pages.entity.managers.empty')}</Text>
				) : (
					managers.map(manager => (
						<EntityManagerRow
							key={manager.id}
							manager={manager}
							file={contactFiles.find(cf => cf.contactId === String(manager.id))?.file}
							onDelete={() => openDeleteModal(manager)}
							isReadOnly={isReadOnly}
						/>
					))
				)}
			</Box>
		</>
	);
};

export default EntityManagersBox;

const AddButton = ({ onClick, disabled }: { onClick: () => void; disabled?: boolean }) => (
	<Button
		size="sm"
		borderRadius="md"
		backgroundColor="black"
		color="white"
		_hover={{ opacity: '0.8' }}
		onClick={onClick}
		padding="0 8px"
		minWidth="32px"
		height="32px"
		disabled={disabled}
	>
		<HiPlus />
	</Button>
);
